import type { IconNode } from '../types';

/**
 * @name target-arrow
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkgMnYzaDMiIC8+CiAgPHBhdGggZD0iTTEzLjQgMTAuNiAyMiAyIiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjIiIC8+CiAgPHBhdGggZD0iTTEyLjMgNkgxMmE2IDYgMCAxIDAgNiA2di0uMyIgLz4KICA8cGF0aCBkPSJNMTUgMi41QTkuOTMgOS45MyAwIDEgMCAyMS41IDkiIC8+CiAgPHBhdGggZD0iTTUuMyAxOS40IDQgMjIiIC8+CiAgPHBhdGggZD0iTTE4LjcgMTkuNCAyMCAyMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/target-arrow
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const targetArrow: IconNode = [
  ['path', { d: 'M19 2v3h3', key: 'ltc2fn' }],
  ['path', { d: 'M13.4 10.6 22 2', key: 'e66hfo' }],
  ['circle', { cx: '12', cy: '12', r: '2', key: '1c9p78' }],
  ['path', { d: 'M12.3 6H12a6 6 0 1 0 6 6v-.3', key: '8shxky' }],
  ['path', { d: 'M15 2.5A9.93 9.93 0 1 0 21.5 9', key: 'xeuvrf' }],
  ['path', { d: 'M5.3 19.4 4 22', key: 'e24ahl' }],
  ['path', { d: 'M18.7 19.4 20 22', key: 'wiqn5j' }],
];

export default targetArrow;
